import React, { Component } from "react";
import { Translate as T } from "react-redux-i18n";
import ReactGA from "react-ga";

import styles from "./NavBar.css";

export default class NavBar extends Component {
  static defaultProps = {
    level: 1
  };

  render = () => {
    const { level, prizes, loading, showSettings, showLevels } = this.props;

    return (
      <nav className={styles.navBar}>
        <button
          className={`${styles.button} ${styles.regenerate} ${loading &&
            styles.loading}`}
          onClick={this.handleRegenerateClick}
        >
          <T value="navBar.regenerate" />
        </button>

        <button
          className={`${styles.button} ${styles.levels} ${showLevels &&
            styles.active}`}
          onClick={this.handleLevelsClick}
          key={level}
        >
          {level}
        </button>

        <button
          className={`${styles.button} ${styles.prizes}`}
          onClick={this.handlePrizesClick}
        >
          <T value="navBar.prizes" />
          {prizes && (
            <span className={styles.badge} key={prizes}>
              {prizes}
            </span>
          )}
        </button>
        <button
          className={`${styles.button} ${styles.settings} ${showSettings &&
            styles.active}`}
          onClick={this.handleSettingsClick}
        >
          <T value="navBar.settings" />
        </button>
      </nav>
    );
  };

  handleRegenerateClick = () => {
    this.props.regenerate();

    ReactGA.event({
      category: "Tools",
      action: "Regenerate"
    });
  };

  handleLevelsClick = () => this.props.toggleLevels();

  handleSettingsClick = () => this.props.toggleSettings();

  handlePrizesClick = () => this.props.togglePrizes();
}



// WEBPACK FOOTER //
// ./src/components/NavBar/NavBar.js